import React, { useEffect, useState, useRef } from 'react';
import {Nav} from "../../components/Nav/Nav";
import {ResearchPaper} from "./ResearchPaper";



export const Publications = () => {

    const papers = [
        {
            citation: "How Reliable are Causal Probing Interventions?",
            authconf: "<u>Marc E. Canby</u>, Adam Davies, Chirag Rastogi, and Julia Hockenmaier, <i>AACL 2025</i>",
            year: 2025,
            links: {
                paper: "https://arxiv.org/pdf/2408.15510"
            },
        },
        {
            citation: "Evaluating and Designing Sparse Autoencoders by Approximating Quasi-Orthogonality",
            authconf: "Sewoong Lee, Adam Davies, <u>Marc E. Canby</u>, and Julia Hockenmaier, <i>COLM 2025</i>",
            year: 2025,
            links: {
                paper: "https://openreview.net/pdf?id=XhdNFeMclS"
            },
        },
        {
            citation: "Benchmarking Query-Conditioned Natural Language Inference",
            authconf: "<u>Marc E. Canby</u>, Xinchi Chen, Xing Niu, Jifan Chen, Bonan Min, Sergul Aydore, and Vittorio Castelli, <i>Findings of ACL 2025</i>",
            year: 2025,
            links: {
                paper: "https://aclanthology.org/2025.findings-acl.765.pdf"
            },
        },
        {
            citation: "LinguiPhyR: A Package for Linguistic Phylogenetic Analysis in R",
            authconf: "<u>Marc E. Canby</u>, <i>JOSS 2024</i>",
            year: 2024,
            links: {
                paper: "https://joss.theoj.org/papers/10.21105/joss.06201#",
                code: "https://github.com/marccanby/linguiphyr"
                // poster: "https://example.com/poster1",
                // video: "https://example.com/video1",
            },
        },
        {
            citation: "Addressing Polymorphism in Linguistic Phylogenetics",
            authconf: "<u>Marc E. Canby</u>, Steven N. Evans, Donald Ringe, and " +
                "Tandy Warnow, <i>TPS 2024</i>",
            year: 2024,
            links: {
                paper: "https://onlinelibrary.wiley.com/doi/10.1111/1467-968X.12289",
                code: "https://github.com/marccanby/LingPhyloSimulator",
                // slides: "https://example.com/slides2",
            },
        },
        {
            citation: "A Framework for Bidirectional Decoding: Case Study in Morphological Inflection",
            authconf: "<u>Marc Canby</u> and Julia Hockenmaier, <i>Findings of EMNLP 2023</i>",
            year: 2023,
            links: {
                paper: "https://aclanthology.org/2023.findings-emnlp.297.pdf",
                code: "https://github.com/marccanby/bidi_decoding",
                video: "https://aclanthology.org/2023.findings-emnlp.297.mp4",
            },
        },
        {
            citation: "Ensemble Deep Learning on Wearables Using Small Datasets",
            authconf: "Taylor Mauldin, Anne H. Ngu, Vangelis Metsis, and " +
                "<u>Marc E. Canby</u>. <i>ACM Trans. Comput. " +
                "Healthcare, 2021</i>",
            year: 2021,
            links: {
                paper: "https://dl.acm.org/doi/10.1145/3428666",
            },
        },
        {
            citation: "Experimentation and Analysis of Ensemble Deep Learning in IoT Applications",
            authconf: "Taylor R. Mauldin, Anne H. H. Ngu, Vangelis Metsis, <u>Marc E. Canby</u>, and Jelena Tesic, <i>OJIOT 2019</i>",
            year: 2019,
            links: {
                paper: "https://www.ronpub.com/ojiot_2019v5i1n11_mauldin.pdf",
            },
        },{
            citation: "SmartFall: A Smartwatch-Based Fall Detection System Using Deep Learning",
            authconf: "Taylor R. Mauldin, <u>Marc E. Canby</u>, Vangelis Metsis, Anne H. H. Ngu, and Coralys Cubero Rivera, <i>Sensors 2018</i>",
            year: 2018,
            links: {
                paper: "https://www.mdpi.com/1424-8220/18/10/3363",
            },
        }
    ];

    const workshopProceedings = [
        {
            citation: "University of Illinois Submission to the SIGMORPHON 2020 Shared Task 0: Typologically Diverse Morphological Inflection",
                authconf: "<u>Marc Canby</u>, Aidana Karipbayeva, Bryan Lunt, Sahand Mozaffari, Charlotte Yoder, and Julia Hockenmaier, <i>SIGMORPHON 2020</i>",
            year: 2020,
            links: {
                paper: "https://aclanthology.org/2020.sigmorphon-1.15.pdf",
            },
        }
    ];

    const preprints = [];

    const conferenceTalks = [
        {
            citation: "Converging Computational Evidence against an East Germanic Clade",
            authconf: "Muhammad Rehan, Sean Liu, and <u>Marc Canby</u>, <i>WeCIEC 2025</i>",
            year: 2025,
            links: {
                // paper: "https://example.com/paper1",
                // poster: "https://example.com/poster1",
                // video: "https://example.com/video1",
            },
        },
        {
            citation: "Reconsidering the Indo-European Tree using Lexical Polymorphisms",
            authconf: "Tandy Warnow, <u>Marc Canby</u>, Sean Liu, Steve Evans, and Don Ringe, <i>WeCIEC 2025</i>",
            year: 2025,
            links: {
                // paper: "https://example.com/paper1",
                // poster: "https://example.com/poster1",
                // video: "https://example.com/video1",
            },
        },
        {
            citation: "Inferring Relative Chronologies from Phylogenetic Data",
            authconf: "<u>Marc E. Canby</u>, Anders Richardt Jørgensen, Simon Poulsen, Matthew Scarborough & Thomas Olander, <i>Relative Chronology in Historical Linguistics 2023</i>",
            year: 2023,
            links: {
                // paper: "https://example.com/paper1",
                // poster: "https://example.com/poster1",
                // video: "https://example.com/video1",
            },
        }
    ];


    // Publications
    const sortedPublications = papers.sort((a, b) => b.year - a.year);
    const groupedPublications = sortedPublications.reduce((acc, paper) => {
        (acc[paper.year] = acc[paper.year] || []).push(paper);
        return acc;
    }, {});

    // Workshops
    const sortedWorkshops = workshopProceedings.sort((a, b) => b.year - a.year);
    const groupedWorkshops = sortedWorkshops.reduce((acc, paper) => {
        (acc[paper.year] = acc[paper.year] || []).push(paper);
        return acc;
    }, {});

    // Preprints
    const sortedPreprints = preprints.sort((a, b) => b.year - a.year);
    const groupedPreprints = sortedPreprints.reduce((acc, paper) => {
        (acc[paper.year] = acc[paper.year] || []).push(paper);
        return acc;
    }, {});

    // Conference Talks
    const sortedConferenceTalks = conferenceTalks.sort((a, b) => b.year - a.year);
    const groupedConferenceTalks = sortedConferenceTalks.reduce((acc, paper) => {
        (acc[paper.year] = acc[paper.year] || []).push(paper);
        return acc;
    }, {});

    const [activeSection, setActiveSection] = useState(null);
    const scrollableRef = useRef(null); // Create a ref for the scrollable container

    const sections = [
        { id: "PublishedWorks", title: "Conference & Journal Proceedings" },
        { id: "Workshops", title: "Workshop Proceedings"},
        { id: "ConferenceTalks", title: "Conference Talks" }
    ];

    const handleSidebarClick = (section) => {
        setActiveSection(section);
        document.getElementById(section.replace(' ', '')).scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {
        const handleScroll = () => {
            console.log("Scroll event triggered"); // Confirm function entry
            const sectionOffsets = sections.map(section => {
                const element = document.getElementById(section.id);
                const offset = element ? element.offsetTop : 0;
                console.log(`Offset for ${section.id}: ${offset}`); // Log the offset
                return offset;
            });

            const currentPosition = scrollableRef.current.scrollTop + (scrollableRef.current.clientHeight / 2);
            console.log(`Current scroll position: ${currentPosition}`); // Log the current position

            const activeIndex = sectionOffsets.findIndex((offset, index) =>
                currentPosition >= offset && (index === sections.length - 1 || currentPosition < sectionOffsets[index + 1])
            );

            console.log(`Active Index: ${activeIndex}`); // Log the active index

            if (activeIndex !== -1 && sections[activeIndex] && activeSection !== sections[activeIndex].id) {
                setActiveSection(sections[activeIndex].id);
            }
        };

        // Add the event listener directly to the ref
        scrollableRef.current.addEventListener("scroll", handleScroll);

        // Cleanup function
        // return () => {
        //     scrollableRef.current.removeEventListener("scroll", handleScroll);
        // };
    }, [activeSection, sections]);

    return (
        <>
            <Nav />
            {/* Page Header */}
            <div className="container-fluid">
                <div className="row">
                    {/* Sidebar */}
                    <div className="col-md-3">
                        <div className="sidebar sticky-top" style={{ position: 'sticky', top: '80px', paddingTop: '20px', paddingLeft: "80px" }}>
                            <div className="container text-center header" style={{marginLeft: "-50px"}}>
                                <h1>Publications</h1>
                            </div>
                            <ul className="nav flex-column" style={{paddingTop: '20px'}}>
                                <li className="nav-item">
                                    <a href="#PublishedWorks" onClick={() => handleSidebarClick('PublishedWorks')} className={activeSection === 'PublishedWorks' ? 'active' : ''}>
                                        Conference & Journal Proceedings
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#Workshops" onClick={() => handleSidebarClick('Workshops')} className={activeSection === 'Workshops' ? 'active' : ''}>
                                        Workshop Proceedings
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#ConferenceTalks" onClick={() => handleSidebarClick('ConferenceTalks')} className={activeSection === 'ConferenceTalks' ? 'active' : ''}>
                                        Conference Talks
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Scrollable Main Content */}
                    <div className="col-md-9" ref={scrollableRef} style={{ height: 'calc(100vh - 100px)', overflowY: 'auto', marginTop: '32px', paddingRight: '80px' }}>

                        <div id="PublishedWorks">
                            <h3 className="my-4">Conference & Journal Proceedings</h3>
                            {Object.keys(groupedPublications).map(Number).sort((a, b) => b - a).map((year) => (
                                <div key={year} className="tabbed">
                                    <h4>{year}</h4>
                                    {groupedPublications[year].map((paper, index) => (
                                        <ResearchPaper key={index} authconf={paper.authconf} citation={paper.citation} year={paper.year} links={paper.links} />
                                    ))}
                                </div>
                            ))}
                        </div>

                        <div id="Workshops">
                            <h3 className="my-4">Workshop Proceedings</h3>
                            {Object.keys(groupedWorkshops).map(Number).sort((a, b) => b - a).map((year) => (
                                <div key={year} className="tabbed">
                                    <h4>{year}</h4>
                                    {groupedWorkshops[year].map((paper, index) => (
                                        <ResearchPaper key={index} authconf={paper.authconf} citation={paper.citation} year={paper.year} links={paper.links} />
                                    ))}
                                </div>
                            ))}
                        </div>

                        {/* Conference Talks Section */}
                        <div id="ConferenceTalks">
                            <h3 className="my-4">Conference Talks</h3>
                            {Object.keys(groupedConferenceTalks).map(Number).sort((a, b) => b - a).map((year) => (
                                <div key={year} className="tabbed">
                                    <h4>{year}</h4>
                                    {groupedConferenceTalks[year].map((paper, index) => (
                                        <ResearchPaper key={index} authconf={paper.authconf} citation={paper.citation} year={paper.year} links={paper.links} />
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}